import { CreateMasterOutletPayload, CreateOutletPayload, CreateUpdateOutletPayload, MasterOutletUpdatePayload } from '@app/api/types';
import { Address } from '@app/api/models';

import { UpdateOutletFormInstance } from '../types'; 

const getStringValue = (value: EntityBase | string | null | undefined) => {
  if (!value) {return null;}
  if (typeof value === 'string') {return value;}
  return value.name;
};

const mapAddress = (address?: Omit<Address, 'region' | 'city'> & { region?: EntityBase; city?: EntityBase; }) => {
  if (!address) {return null;}
  const { id, region, city, ...rest } = address;
  return {
    ...rest,
    region: getStringValue(region),
    city: getStringValue(city),
    ... (id ? { id } : {}),
  };
};

export const mapInstance = (
  instance: UpdateOutletFormInstance
): CreateUpdateOutletPayload => {
  return {
    outlet_id: instance.outlet_id,
    status_id: Number(instance.status.id),
    name: instance.name || '',
    title: instance.title || '',
    subnet: instance.subnet || '',
    address: mapAddress(instance.address),

    visits_day: instance.visits_day,
    route_number_id: instance.route_number ? Number(instance.route_number.id) : undefined,

    director: instance.director,
    phone: instance.phone,
    email: instance.email,
    contact_person_1: instance.contact_person_1,
    contact_person_2: instance.contact_person_2,

    sub_channel_id: Number(instance.sub_channel.id),
    distributor_id: Number(instance.distributor.id),
    comment: instance.comment,
  };
};


export const mapUpdateInstance = (
  update_id: string,
  instance: any
): MasterOutletUpdatePayload => {
  return {
    id: update_id,
    outlet_id: instance.id,
    status_id: Number(instance.status.id),

    name: instance.name || '',
    title: instance.title || '',
    subnet: instance.subnet || '',
    address: instance.address ? {
      ...instance.address,
      region: instance.address.region ? instance.address.region.name : null,
      city: instance.address.city ? instance.address.city.name : null,
    } : null,

    visits_day: instance.visits_day,
    route_number_id: Number(instance.route_number.id),

    director: instance.director,
    phone: instance.phone || '-',
    email: instance.email,
    contact_person_1: instance.contact_person_1,
    contact_person_2: instance.contact_person_2,

    sub_channel_id: Number(instance.sub_channel.id),
    distributor_id: Number(instance.distributor.id),
  };
};


